<style scoped lang="scss">
    @import "../../styles/mixins";
    @import "../../styles/var";
</style>

<template>
    <div>
        <v-title title="诊断资料" style="margin-left: -15px"></v-title>
        <el-form ref="form" :model="form" label-width="70px" label-position="left" size="mini">
            <el-form-item label="影像类型">
                <el-select v-model="form.region" placeholder="影像类型">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="病历补充信息" label-width="100px"></el-form-item>
            <el-form-item>
                <div class="" slot="label" style="line-height: 20px">病情摘要</div>
                <v-textarea placeholder="请输入申请会诊目的（或事由）" :maxlength="500"></v-textarea>
            </el-form-item>
            <el-form-item label="选择诊断影像" label-width="100px">
                <div>
                    <el-upload
                        class="upload-demo"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :file-list="fileList">
                        <el-button size="small" type="primary">选择资料</el-button>
                        <div slot="tip" class="fs14 color_333">仅支持pdf、xls、xlsx、doc、docx、txt、rar、zip格式，文件小于500M。</div>
                    </el-upload>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";
  import VTextarea from "../common/v-textarea";

  export default {
    name: "diagnose-diagnose-form",
    components: {VTextarea, VTitle},
    props: {
      value: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        fileList: [],
        form: {}
      }
    },
  }
</script>
